export const CURRENT_USER_NAME_NUMBER_KEY = "currentUserNameNumber";
export const CURRENT_USER_IP_BASE_NUMBER_KEY = "currentUserIpBaseNumber";
export const CURRENT_USER_ACCOUNT_NUMBER_KEY = "currentUserAccountNumber";
export const CURRENT_VIEW_AS_USER_NAME_KEY = "currentViewAsUserName";
export const CURRENT_USER_GUID_KEY = "currentUserGuid";
export const CURRENT_USER_EMAIL_KEY = "userEmail";
export const CURRENT_USER_NAME_KEY = "username";

export interface IActiveMemberContext {
    currentUserNameNumber?: string;
    currentUserIpBaseNumber?: string;
    currentUserAccountNumber?: string;
    currentViewAsUserName?: string;
    currentUserGuid?: string;
	currentUser?: string;
}

export const AccountSessionStorage = {

    load(): IActiveMemberContext {
        return {
            currentUserNameNumber: sessionStorage.getItem(CURRENT_USER_NAME_NUMBER_KEY) || undefined,
            currentUserIpBaseNumber: sessionStorage.getItem(CURRENT_USER_IP_BASE_NUMBER_KEY) || undefined,
            currentUserAccountNumber: sessionStorage.getItem(CURRENT_USER_ACCOUNT_NUMBER_KEY) || undefined,
            currentViewAsUserName: sessionStorage.getItem(CURRENT_VIEW_AS_USER_NAME_KEY) || undefined,
            currentUserGuid: sessionStorage.getItem(CURRENT_USER_GUID_KEY) || undefined,
            currentUser: sessionStorage.getItem(CURRENT_USER_EMAIL_KEY) || undefined
        };
    },

    save(context: IActiveMemberContext): void {
        if (context.currentUserNameNumber !== undefined) {
            sessionStorage.setItem(CURRENT_USER_NAME_NUMBER_KEY, context.currentUserNameNumber);
        } else {
            sessionStorage.removeItem(CURRENT_USER_NAME_NUMBER_KEY);
        }

        if (context.currentUserIpBaseNumber !== undefined) {
            sessionStorage.setItem(CURRENT_USER_IP_BASE_NUMBER_KEY, context.currentUserIpBaseNumber);
        } else {
            sessionStorage.removeItem(CURRENT_USER_IP_BASE_NUMBER_KEY);
        }

        if (context.currentUserAccountNumber !== undefined) {
            sessionStorage.setItem(CURRENT_USER_ACCOUNT_NUMBER_KEY, context.currentUserAccountNumber);
        } else {
            sessionStorage.removeItem(CURRENT_USER_ACCOUNT_NUMBER_KEY);
        }

        if (context.currentViewAsUserName !== undefined) {
            sessionStorage.setItem(CURRENT_VIEW_AS_USER_NAME_KEY, context.currentViewAsUserName);
        } else {
            sessionStorage.removeItem(CURRENT_VIEW_AS_USER_NAME_KEY);
        }

        if (context.currentUserGuid !== undefined) {
            sessionStorage.setItem(CURRENT_USER_GUID_KEY, context.currentUserGuid);
        } else {
            sessionStorage.removeItem(CURRENT_USER_GUID_KEY);
        }
    },

    clear(): void {
        sessionStorage.removeItem(CURRENT_USER_NAME_NUMBER_KEY);
        sessionStorage.removeItem(CURRENT_USER_IP_BASE_NUMBER_KEY);
        sessionStorage.removeItem(CURRENT_USER_ACCOUNT_NUMBER_KEY);
        sessionStorage.removeItem(CURRENT_VIEW_AS_USER_NAME_KEY);
        sessionStorage.removeItem(CURRENT_USER_GUID_KEY);
    }
};